package game.entity

import game.Game
import game.Room
import game.Weapon

class KrakenHead : Enemy(hp = 8) {
    var onHit: () -> Unit = {}
    var onDone: () -> Unit = {}
    private var step = 0
    private var coolDown = 0

    override fun onInit(game: Game, room: Room) {
        step = 0
        damageCoolDown = 0
        width = 5
        height = 3
    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                sprite = game.getSpriteById("kraken-head-3")
                step++
                coolDown = 20
            }
            1 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            2 -> {
                sprite = game.getSpriteById("kraken-head-2")
                step++
                coolDown = 20
            }
            3 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            4 -> {
                sprite = game.getSpriteById("kraken-head-1")
                step++
                coolDown = 20
            }
            5 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            6 -> {
                room.addEntity(Projectile(0.1).also {
                    it.col = col + 2
                    it.row = row + 2
                    it.startAttack(game, col, row, game.player.col, game.player.row, "mucus-ball")
                })
                if (hp < 3) {
                    coolDown = 50
                    step++
                } else {
                    coolDown = 100
                    step += 3
                }
            }
            7 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            8 -> {
                room.addEntity(Projectile(0.1).also {
                    it.col = col + 2
                    it.row = row + 2
                    it.startAttack(game, col, row, game.player.col, game.player.row, "mucus-ball")
                })
                coolDown = 50
                step++
            }
            9 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            10 -> {
                sprite = game.getSpriteById("kraken-head-1")
                step++
                coolDown = 20
            }
            11 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            12 -> {
                sprite = game.getSpriteById("kraken-head-2")
                step++
                coolDown = 20
            }
            13 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            14 -> {
                sprite = game.getSpriteById("kraken-head-3")
                step++
                coolDown = 20
            }
            15 -> {
                coolDown--

                if (coolDown == 0) {
                    step++
                }
            }
            16 -> {
                room.removeEntity(this)
                onDone.invoke()
            }
        }
    }

    override fun onAttacked(game: Game, weapon: Weapon) {
        if (damageCoolDown == 0) {
            takeDamage(game, 0)
            onHit.invoke()
        }
    }
}